import {logout as amplifyLogout} from "../services/auth";
import { recordLogout } from "../pages/users/api/usersApi.js";

/** Sign out of Cognito (clears Amplify-managed tokens), then clear the app session. */
function signOut() {
    amplifyLogout().finally(() => {
        sessionStorage.clear();
        return window.location.href = "/";
    });
}

/*
 * Log the logout, then sign out. The log goes through the user Lambdas (cloud or non-cloud,
 * like every user change), which take the user from the signed-in token; it was a /myrest
 * write that took the user id from the request (docs/MYREST_MIGRATION_AUDIT.md).
 *
 * Used by both navigations. Only migrated users have a core_user row to log against, so a
 * non-migrated session just signs out. Whatever happens to the log, the sign-out goes ahead.
 */
function Logout(dData) {
    if (!dData?.migrated) {
        signOut();
        return;
    }
    try {
        recordLogout({campusId: dData.acnt, userId: dData.user, clientId: dData.sessionId,
                      migrated: dData.migrated})
            .catch(() => undefined)
            .finally(signOut);
    } catch (e) {
        signOut();
    }
}

export default Logout;
